import '../sass/hero.scss';

(() => {
    const plyrScript = document.querySelector('#icrav-2027-plyr-js');
    const $blocks = document.querySelectorAll('.hero');

    if (!$blocks) return;
    
    $blocks.forEach($block => {
        const $videoModal = $block.querySelector('.hero__video-modal');
        const $video = $block.querySelector('.hero__video-modal-video');

        const initVideos = () => {
            if (!$videoModal || !$video) return;

            const player = new Plyr($video, {
                controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen'],
                disableContextMenu: false,
            });

            $videoModal.addEventListener('modalopen', () => {
                player.play();
            });

            $videoModal.addEventListener('modalafterclose', () => {
                player.stop();
            });
        };

        if (typeof Plyr !== 'undefined') {
            initVideos();
        } else if (plyrScript) {
            plyrScript.addEventListener('load', () => {
                initVideos();
            });
        } else {
            window.addEventListener('load', () => {
                if (!plyrScript) return;
                
                plyrScript.addEventListener('load', () => {
                    initVideos();
                });
            });
        }
    });
})();
